export default "__VITE_ASSET__BrjPnsH4__"